export const initialDocumentState = {
  templateId: null,
  title: "",
  subtitle: "",
  contact: {
    email: "",
    phone: "",
    location: ""
  },
  sections: [],
  style: {
    fontFamily: "'Inter', sans-serif",
    headerColor: "#3b82f6",
    accentColor: "#60a5fa"
  }
};
